import React, { useContext, useEffect, Component } from 'react'
import { authContext } from '../../Login/AuthContext';
import Checkboxs from '../Ventilation/Checkbox'

var zones = [];

const SelectAreas = () => {
  const { auth } = useContext(authContext);

  useEffect(() => {
    if (auth.data.zones)
      zones = auth.data.zones;
  }, [auth.data])

  if(!auth.data.zone)
    return;
  return (
    <div className="container" key="areas_container">
        <div className="alert alert-primary" role="alert" key="areas_clickingBar">Recherche de zones géographiques</div>
        <SearchBox/>
        <hr/>
    </div>
  )}

export default SelectAreas;

class SearchBox extends Component {
  state = {
    results : []
  };
  static contextType = authContext;

  useEffect = () => {
    if(!this.context.auth.data.selectedZones)
      this.setState({choice:[]})
    else
      this.setState({choice:this.context.auth.data.selectedZones})
  }

  handleInputChange = event => {
    if(!zones)
      return;
    var result = [];
    zones.map((zone,i) => {
      if(zone.name.search(new RegExp(event.target.value, "i"))>=0)
        result.push(zone);
      return 1;
    })
    this.setState({results:result})
  }

  addZone = elem =>{
    var data = this.context.auth.data;
    var choice;
    if(!data.selectedZones)
      choice = [];
    else
      choice = data.selectedZones;
    //choice.push(zones[i])
    choice.push(this.state.results[elem.target.value])
    data.selectedZones = choice;
    this.context.setAuthData(data);
  }

  removeZone = elem =>{
    var data = this.context.auth.data;
    var choice = data.selectedZones;
    //choice.push(zones[i])
    choice.splice(elem.target.value, 1)
    data.selectedZones = choice;
    this.context.setAuthData(data);
  }

  render () {
    return (
      <div className="row" id="select_areas">
        <div key="SearchBox" className="col">
          <form>
            <input type="text" id="filter" placeholder="Nom de la zone..."  onChange={this.handleInputChange}/>
          </form>
          <ul>
            {this.state.results.map((elem, i) =>
              <li key={"search_"+i}>
                {elem.name}
                <button onClick={this.addZone} value={i}>+</button>
              </li>
            )}
          </ul>
        </div>
        <div key="Checkboxs" className="col">
          <Checkboxs/>
        </div>
      </div>
    )
  }
}
/*
<h3>Selected Areas</h3>
<ul>
  {this.context.auth.data.selectedZones.map((elem, i) =>
    <li key={"choice_"+i}>{elem.name} <button onClick={this.removeZone} value={i}>-</button></li>
  )}
</ul>
*/
